import React, { useState, useEffect } from "react";

const Preloader = () => {
  const [loading, setLoading] = useState(true);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const handleLoad = () => {
      // Start fade-out animation
      setClosing(true);
      // Remove preloader from DOM after animation
      setTimeout(() => {
        setLoading(false);
      }, 500); // This should match the duration of the fade-out animation
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);

  if (!loading) {
    return null;
  }

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white text-white transition-opacity duration-500 ${
        closing ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="relative flex items-center justify-center">
        <img
          src="../assets/VRIFY_Africa_full_logo[1].png"
          alt="Loading..."
          className="h-28 w-28 md:h-44 md:w-48 animate-pulse"
        />
        {/* Optional: Spinner ring around the logo */}
        <div className="absolute h-28 w-28 md:h-40 md:w-40 rounded-full border-t-2 border-b-2 border-green-400 animate-spin"></div>
      </div>
      {/* <p className="mt-4 text-sm tracking-wider">loading, please wait...</p> */}
    </div>
  );
};

export default Preloader;